import React from 'react';
import { FormattedMessage } from 'react-intl';

import Constants from '../../../../definitions/constants';
import FormatTooling from '../../../../tooling/formatTooling';
import LocaleTooling from '../../../../tooling/localeTooling';
import { intl } from '../../../../locales/localesConfig';

import Spinner from '../interface/spinner';
import TextBox from '../inputs/textBox';
import CheckBox from '../inputs/checkBox';
import Select from '../inputs/select';
import TagsSelector from '../inputs/tagsSelector';

const getColumnWidth = (column,totalWidth) => {
  return  column.size ? 
            String(column.size).includes("px") ? 
              column.size :
              100*column.size/totalWidth + "%"
            : "auto";
};

const getColumnsTotalWidth = (entityTableDescriptor, showAuditColumn, auditColumnSize) => {
  var totalWidth = 0;
  for(var i=0; i<entityTableDescriptor.columns.length; i++) {
    var column = entityTableDescriptor.columns[i];
    if(column.size && !String(column.size).includes("px")) {
      totalWidth += column.size;
    }
  }
  totalWidth += showAuditColumn ? auditColumnSize : 0;
  return totalWidth;
};

const getColorClass = (colorConfig, entity) => {
  if(!colorConfig) {
    return "";
  }
  let colorClass = ""
  colorConfig.forEach((colorConfigInstance) => {
    if(entity[colorConfigInstance["column"]] == colorConfigInstance["value"]) {
      colorClass = "table_color_row_" + colorConfigInstance["color"];
    }
  });
  return " " + colorClass;
};

/* Color config example (multiple configs accepted in the array)
[{
  color: "red",
  column: "has_error",
  value: true
}]*/

const EntityTable = props => {
  const {
    entityTableDescriptor,
    data,
    selectedId,
    noSelectedText,
    loading,
    page,
    totalPages,
    totalRecords,
    orderBy,
    orderByDirection,
    topControlsFormData,
    handleOnChangeTopControls,
    fetchOrderList,
    fetchListChangePage,
    handleShowFormPopup,
    handleDelete,
    handleActive,
    handleCustomActions,
    customActionsIcons,
    customActionsTooltips,
    handleRowClick,
    extraControls,
    hideActions,
    showBaseActionsField,
    disableDisbledEntitiesControl,
    colorConfig,
    customActionsForceShow,
    showDisabledEntitiesText,
    conditionalCustomActionHide,
    handleShowAuditPopup,
    loadingTextPlaceholder, // string: Placeholder to show when loading is true and data is null.
    enableTagsSearch,
    tagsOptions,
    className
  } = props;
  var auditColumnSize = entityTableDescriptor.auditColumnSize ? entityTableDescriptor.auditColumnSize : 1;
  var enableAuditInfoControl = (entityTableDescriptor.auditColumnInfo) ? true : false;
  var showAuditColumn = (topControlsFormData && topControlsFormData.showAuditColumn && enableAuditInfoControl) ? true : false;  
  var totalColumnsWidth = getColumnsTotalWidth(entityTableDescriptor, showAuditColumn, auditColumnSize);

  return (
    <div className={"table_component entity_table_component" + (className ? " " + className : "")}>
      <div className="top_controls">
        {topControlsFormData && (
          <TextBox 
            className="top_controls_search"
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="searchText"
            value={topControlsFormData.searchText}
            onChange={handleOnChangeTopControls}
            labelLocale={<FormattedMessage 
              id="common.entity.findEntity"
              values={{entityNamePlural: entityTableDescriptor.entityNamePlural}}
            />}
            showClearTextButton={true}
          />
        )}
        {(topControlsFormData && !disableDisbledEntitiesControl) && (
          <CheckBox 
            className="top_controls_show_disabled_entities"
            id="showDisabledEntities"
            value={topControlsFormData.showDisabledEntities}
            onChange={handleOnChangeTopControls}
            labelLocale={!showDisabledEntitiesText ? (<FormattedMessage 
              id="common.entity.showDisabledEntities" 
              values={{genderVocal: entityTableDescriptor.genderVocal}}
              />) : showDisabledEntitiesText}
              />
            )}
        {(topControlsFormData && enableAuditInfoControl) && (
          <CheckBox 
            className="top_controls_show_audit_info"
            id="showAuditColumn"
            value={topControlsFormData.showAuditColumn}
            onChange={handleOnChangeTopControls}
            labelLocale={"Mostrar auditoría"}
            />
          )}
        <div className="top_controls_extra_controls">
          {extraControls}
        </div>
        {(topControlsFormData && enableTagsSearch) && (
          <TagsSelector 
            id="selectedTags"
            data-path="selectedTags"
            values={topControlsFormData.selectedTags}
            options={tagsOptions}
            onClickOption={handleOnChangeTopControls}
            hideSelectedTags={false}
            searchLabelLocale={intl.formatMessage({ id: "common.entity.entityTable.tagsLabelLocale"})}
            hideTitle={true}
            disabled={false}
            disableOnKeyEnterAction={true}
            maxOptionsBeforeScroll={10}
          />
        )}
        <div className="registers_info">
          <span className="page_info page_info_total">
            {(totalRecords ? totalRecords : 0) + " " + entityTableDescriptor.entityNamePlural + " - "}
          </span>
          {(page>1) && (
            <span className="pag_arrow pag_arrow_left" data-targetpage={page-1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-left"></i>
            </span>
          )}
          <span className="page_info">
            <FormattedMessage 
              id="common.entity.entityTable.pageInfo"
              values={{page: totalPages==0 ? 0 : Math.min(page,totalPages), totalPages: totalPages}}
            />
          </span>
          {(page<totalPages && totalPages>1) && (
            <span className="pag_arrow pag_arrow_right" data-targetpage={page+1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-right"></i>
            </span>
          )}
        </div>
      </div>
      {entityTableDescriptor!=null ? (
        <div className="table_component_table_wrapper">
          <div className="table_component_table_header_wrapper">
            <table>
              <thead>
                <tr>
                  {(!hideActions) && (<th className="actions_column"></th>)}
                  {entityTableDescriptor.columns.map( (entityColumn,i) => {
                    return (
                      <th 
                        key={i}
                        data-field={entityColumn.sortField ? entityColumn.sortField : entityColumn.key}
                        className={
                          (entityColumn.align ? " align_" + entityColumn.align.toLowerCase() : "") +
                          (entityColumn.sortable ? " sortable_column" : "") +
                          ((entityColumn.sortable && (entityColumn.key==orderBy || entityColumn.sortField==orderBy)) ? " active_sort_" + orderByDirection : "")
                        }
                        style={{ 
                          width: getColumnWidth(entityColumn, totalColumnsWidth)
                        }}
                        onClick={entityColumn.sortable ? fetchOrderList : null}
                      >
                        <div title={entityColumn.label}>{entityColumn.label}</div>
                      </th>
                    );
                  })}
                  {showAuditColumn && (
                    <th 
                      key={-1}
                      style={{ 
                        width: getColumnWidth({size: auditColumnSize }, totalColumnsWidth)
                      }}
                    >
                      <div title={intl.formatMessage({ id:"calculationUnitAdmin.auditColumnLabel" })}>
                        <FormattedMessage 
                          id="calculationUnitAdmin.auditColumnLabel"
                        />
                      </div>
                    </th>
                  )}
                </tr>
              </thead>
            </table>
          </div>
          <div className="table_component_table_body_wrapper">
            <table>
              <thead>
                <tr>
                  {!hideActions && (<th className="actions_column"></th>)}
                  {entityTableDescriptor.columns.map( (entityColumn,i) => {
                    return (<th key={i} style={{width: getColumnWidth(entityColumn, totalColumnsWidth)}}>{""}</th>);
                  })}
                  {showAuditColumn && (
                    <th key={-1} style={{width: getColumnWidth({size: auditColumnSize }, totalColumnsWidth)}}>{""}</th>
                  )}
                </tr>
              </thead>
              <tbody>
              {data && data.map((entityRecord,i) => {
                return (
                  <tr  
                    className={(handleRowClick ? "clickable_row" : "") + 
                      (selectedId==entityRecord.id ? " selected_row" : "") +
                      (entityRecord.blocked ? " blocked_row" : "") + 
                      getColorClass(colorConfig, entityRecord)}
                    onClick={handleRowClick}
                    data-entitydata={JSON.stringify(entityRecord)}
                    key={i}
                  >
                    {!hideActions && (
                      <td className="actions_column">
                        {(!entityRecord.blocked && handleShowFormPopup && (!showBaseActionsField || entityRecord[showBaseActionsField])) && (
                          <i 
                            data-entitydata={JSON.stringify(entityRecord)}
                            className="fas fa-edit"
                            onClick={handleShowFormPopup}
                            title={intl.formatMessage({ id: "common.entityTableActions.edit"})}
                          />
                        )}
                        {(!entityRecord.blocked && handleDelete && (!showBaseActionsField || entityRecord[showBaseActionsField])) && (
                          <i 
                            data-id={JSON.stringify(entityRecord.id)}
                            data-entitydata={JSON.stringify(entityRecord)}
                            className="fas delete-action fa-trash"
                            onClick={handleDelete}
                            title={intl.formatMessage({ id: "common.entityTableActions.delete"})}
                          />
                        )}
                        {(!entityRecord.blocked && handleActive && (!showBaseActionsField || entityRecord[showBaseActionsField])) && (
                          <i 
                            data-entitydata={JSON.stringify(entityRecord)}
                            className={"toggle fas " + (entityRecord.active ? "fa-toggle-on" : "fa-toggle-off")}
                            onClick={handleActive}
                            title={intl.formatMessage({ id: "common.entityTableActions.activate"})}
                          />
                        )}
                        {(handleCustomActions) && 
                          handleCustomActions.map((handleCustomAction,handleCustomActionIndex) => {
                            return ((!entityRecord.blocked || (customActionsForceShow && customActionsForceShow[handleCustomActionIndex])
                            ) && !(conditionalCustomActionHide && entityRecord[conditionalCustomActionHide[handleCustomActionIndex]])) && (
                              <i
                                key={handleCustomActionIndex}
                                data-entitydata={JSON.stringify(entityRecord)}
                                className={"fas custom-action fa-" + customActionsIcons[handleCustomActionIndex]}
                                onClick={handleCustomAction}
                                title={customActionsTooltips[handleCustomActionIndex]}
                              />
                            );
                          })
                        }                        
                      </td>
                    )}
                    {entityTableDescriptor.columns.map( (entityColumn,i) => {
                      var value = FormatTooling.defaultsTextFormatTypes(entityRecord[entityColumn.key],entityColumn.dataType);
                      if(entityColumn.translateList) {
                        value = LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: entityColumn.translateList + "." + value}));
                      }                  
                      return (
                        <td key={i} className={entityColumn.align ? "align_" + entityColumn.align.toLowerCase() : ""}>
                          <div title={value}>{value}</div>
                        </td>
                      );
                    })}
                    {showAuditColumn && (
                      <td className="audit_column">
                        <div title={entityRecord[entityTableDescriptor.auditColumnInfo]}>
                          {entityRecord[entityTableDescriptor.auditColumnNotificationId] && (
                            <i 
                              className="fas fa-info-circle"
                              data-entitydata={JSON.stringify({notification_id: entityRecord[entityTableDescriptor.auditColumnNotificationId]})}
                              onClick={handleShowAuditPopup}
                              title={intl.formatMessage({ id: "common.entityTableActions.auditJobInfo"})}
                            />
                          )}
                          {entityRecord[entityTableDescriptor.auditColumnInfo]}
                        </div>                        
                      </td>
                    )}
                  </tr>                      
                );    
              })}
              </tbody>
            </table>
            {(noSelectedText!=null && ((data==null || data.length==0) && !loading)) && (
              <div className="no_selected_text">
                {noSelectedText}
              </div>
            )}
            {((data==null && loading && loadingTextPlaceholder)) && (
              <div className="no_selected_text">
                {loadingTextPlaceholder}
              </div>
            )}
            {loading && (<div className="table_eof">
              <Spinner/>
              <span>
                <FormattedMessage 
                  id="common.entity.entityTable.loadingRegisters" 
                  values={{entityNamePlural: entityTableDescriptor.entityNamePlural}}
                />
              </span>
            </div>)}
          </div>
        </div>
      ) : null}
      {(!loading && page >= totalPages) && (<div className="table_eof">
        <i className="fas fa-check-circle"/>
        <span>
          <FormattedMessage 
            id="common.entity.entityTable.noMoreRegisters" 
            values={{
              entityNamePlural: entityTableDescriptor.entityNamePlural,
              genderVocal: entityTableDescriptor.genderVocal
            }}
          />
        </span>
      </div>)}
    </div>
  );
}

export default EntityTable;



// WEBPACK FOOTER //
// ./source/client/components/common/entity/entityTable.jsx